import React, { useState, useEffect } from 'react';
import { leaveAPI } from '../../services/api';
import ApproveLeaves from '../leave/ApproveLeaves';
import '../../styles/LeaveManagement.css';

const AdminLeaveApproval = () => {
  const [leaveStats, setLeaveStats] = useState({
    total_pending: 0,
    total_approved: 0,
    total_rejected: 0
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadLeaveStats();
  }, []);

  const loadLeaveStats = async () => {
    try {
      setLoading(true);
      const stats = await leaveAPI.getLeaveStats();
      setLeaveStats(stats);
    } catch (error) {
      console.error('Error loading leave stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-leave-approval">
      {/* Stats Summary */}
      <div className="leave-stats-grid">
        <div className="stat-card">
          <div className="stat-icon pending">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <span className="stat-value">{leaveStats.total_pending}</span>
            <span className="stat-label">Pending Approvals</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon approved">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <span className="stat-value">{leaveStats.total_approved}</span>
            <span className="stat-label">Approved</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon rejected">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-content">
            <span className="stat-value">{leaveStats.total_rejected}</span>
            <span className="stat-label">Rejected</span>
          </div>
        </div>
      </div>

      {/* Approval Table */}
      <div className="approval-section">
        <ApproveLeaves showDepartmentView={false} />
      </div>
    </div>
  );
};

export default AdminLeaveApproval;
